export default "__VITE_ASSET__C$flMyUP__"